'use client';
import { RenderBlocks } from '@/components/blocks/render-blocks';
import styles from './meeting-place-page-home.module.scss';
import { useEffect } from 'react';
import useNewsletterPopupAutomation from '@/hooks/useNewsletterPopupAutomation';
import dynamic from 'next/dynamic';
import {
  useGetLibraryConstantsDictionaryData,
  useTenantConfig,
} from '@/providers/ConfigProvider';
import { useCrowdLevel } from '@/context/CrowdLevelContext';
const GtmPageView = dynamic(
  () =>
    import('@/components/page-components/analytics/gtm-page-view').then(
      (mod) => mod.GtmPageView,
    ),
  { ssr: false },
);

interface HomeProps {
  node_locale: string;
  homePageData: any;
  isLivliFamily?: boolean;
  ikeaFamilyBenefit?:
    | import('@/lib/getIkeaFamilyBenefits').IkeaFamilyBenefitItem
    | null;
}

export default function Home({
  node_locale,
  homePageData,
  isLivliFamily = false,
  ikeaFamilyBenefit,
}: HomeProps) {
  const homePageDataResolved: any = homePageData?.meetingPlacePageHome;
  const dictionary = useGetLibraryConstantsDictionaryData();
  const crowdLevel = useCrowdLevel();
  const config = useTenantConfig();
  const showCrowdIndicator =
    config?.NEXT_PUBLIC_SHOW_CROWD_INDICATOR === 'true';

  const cardList =
    homePageDataResolved?.meetingPlace?.cardList?.cardsCollection?.items?.filter(
      Boolean,
    ) || [];
  const mainBannerList = homePageDataResolved?.meetingPlace?.mainBannerList
    ?.mainBannerItemsCollection
    ? [homePageDataResolved?.meetingPlace?.mainBannerList]
    : [];
  const showIkeaProductCard =
    homePageDataResolved?.meetingPlace?.cardList?.showIkeaProductsCard;

  useNewsletterPopupAutomation();

  // Check for url params
  useEffect(() => {
    const windowUrl = window.location.search;
    const params = new URLSearchParams(windowUrl);
    const email = params.get('EmailId');
    const subscribe = params.get('subscribe');
    if (email && subscribe === 'false') {
      const newsletterButton = document.getElementById('newsletter-button');
      newsletterButton?.click();
    }
  }, []);

  return (
    <>
      {homePageDataResolved?.meetingPlace && (
        <>
          <GtmPageView
            homepage={homePageDataResolved}
            language={node_locale}
            pageTitle={homePageDataResolved?.meetingPlace?.name}
            excludeBrowserTitleSuffix
          />
          <main className="grid grid-cols-11 gap-5 lg:-ml-22">
            <div className="col-span-11 lg:col-span-5">
              <RenderBlocks
                blocks={mainBannerList}
                logo={homePageDataResolved?.meetingPlace.logo}
                meetingPlaceName={homePageDataResolved?.meetingPlace.name}
                node_locale={node_locale}
                businessUnitCode={
                  homePageDataResolved?.meetingPlace?.businessUnitCode
                }
                timezone={homePageDataResolved?.meetingPlace?.timezone}
              />
            </div>

            <div
              className={`col-span-11 px-6 lg:col-span-6 lg:mt-6 lg:px-0 ${showCrowdIndicator && crowdLevel !== null ? styles.cardHolder : styles.cardHolderNoCrowd}`}
            >
              <RenderBlocks
                blocks={cardList}
                masonry
                businessUnitCode={
                  homePageDataResolved?.meetingPlace?.businessUnitCode
                }
                node_locale={node_locale}
                primaryLanguage={node_locale}
                meetingPlaceName={homePageDataResolved?.meetingPlace?.name}
                htmlTitleSuffix={homePageDataResolved?.htmlTitleSuffix}
                showIkeaProductCard={showIkeaProductCard}
                dictionary={dictionary}
                isLivliFamily={isLivliFamily}
                cardList={cardList}
                ikeaFamilyBenefit={ikeaFamilyBenefit}
              />
            </div>
          </main>
        </>
      )}
    </>
  );
}
